export const getMergedTopicStatus = (
	topics: Topic[],
): CompletionStatus | null => {
	const completedTopic = topics.find(
		(topic: Topic) => topic.completion_status?.status === 'completed',
	)
	if (completedTopic?.completion_status) return completedTopic.completion_status

	const startedTopic = topics.find(
		(topic: Topic) => topic.completion_status?.status === 'started',
	)
	if (startedTopic?.completion_status) return startedTopic.completion_status

	return null
}

export const buildMergedTopics = (topics: Topic[]): MergedTopics[] => {
	const mergedTopics: MergedTopics[] = []
	topics.forEach((topic: Topic) => {
		const mergeTopic = mergedTopics.find(
			(mergedTopic: MergedTopics) => mergedTopic.title === topic.title,
		)
		if (mergeTopic) {
			mergeTopic.topics.push({
				...topic,
				topicIndex: mergeTopic.topics[0].topicIndex,
			})
		} else {
			mergedTopics.push({
				title: topic.title,
				completionStatus: null,
				topics: [
					{
						...topic,
						topicIndex: `${mergedTopics.length}`.padStart(2, '0'),
					},
				],
			})
		}
	})
	mergedTopics.forEach((mergedTopic: MergedTopics) => {
		mergedTopic.completionStatus = getMergedTopicStatus(mergedTopic.topics)
	})
	return mergedTopics
}
